// extracted by mini-css-extract-plugin
module.exports = {"readMore":"ReadMorePart_readMore__KOkju"};